<template>
  <div class="region-home position-relative">
    <b-overlay :show="languageBusy">
      <pagination :meta="languagesMeta" place-holder="تىل نامىنى كىرگۈزۈپ ئىزدەڭ" @change-page="onChangePage" @refresh="onRefresh">
        <b-button slot="action" :to="{name: 'language.store'}" class="btn btn-label-success btn-sm border-0">
          يېڭىدىن قوشۇش
        </b-button>
      </pagination>
      <b-row>
        <b-col v-for="language in languages" :key="`language_${language.id}`" md="3" sm="6">
          <portlet :title="language.title" body-fluid body-class="px-3 pb-3 pt-0" headNoBorder head-class="px-2" head-size="sm">
            <template slot="toolbar">
              <b-dropdown v-b-tooltip title="مەشغۇلات" toggle-class="text-decoration-none border-0 btn btn-clean btn-sm btn-icon btn-icon-md" no-caret>
                <template v-slot:button-content>
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-text >
                  <b-checkbox switch v-model="language.is_show" @change="onChangeSwitch( language.id, 'is_show', $event )"> ھالىتى </b-checkbox>
                </b-dropdown-text>
                <b-dropdown-divider />
                <b-dropdown-item :to="{name: 'language.edit', params: {id: language.id}}">
                  <i class="fa fa-info-circle"></i> تەھرىرلەش
                </b-dropdown-item>
                <b-dropdown-item @click="onClickDelete(language.id)">
                  <i class="fa fa-trash"></i> ئۆچۈرۈش
                </b-dropdown-item>
              </b-dropdown>
            </template>
            <template slot="body">
              <div class="kt-widget-item-container">
                <div class="kt-widget kt-widget--user-profile-2">
                  <div class="kt-widget__body">
                    <div class="kt-widget__item">
                      <div class="kt-widget__contact">
                        <span class="kt-widget__label">كىنو سانى: </span>
                        <span class="kt-widget__data"> {{ language.films_count }} پارچە </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </portlet>
        </b-col>
      </b-row>
      <no-result :visible="!languages.length" background="warning" title="ئۇچۇر تېپىلمىدى" desc="مۇناسىۋەتلىك ئ‍ۇچۇر تېپىلمىدى، يېڭىدىن تىل قوشۇڭ." >
        <template slot="action">
          <b-button :to="{name: 'language.store'}" class="btn-custom btn-bold btn-upper btn-font-sm  btn-warning">تىل قوشۇش</b-button>
        </template>
      </no-result>
    </b-overlay>
  </div>
</template>

<script>
  import Portlet from "@v@/partials/content/Portlet";
  import NoResult from "@v@/partials/content/NoResult";
  import languageMixin from "@m@/language.mixin";
  import formBusyMixin from "@m@/common/formBusy.mixin";
  import pagination from "@v@/components/paginate";
  import BreadCrumbs from "@c@/breadcrumbs.service";
  import commonMethodMixin from "@m@/common/common.method.mixin";
  import msgBoxConfirmMixin from "@m@/common/msgBoxConfirmMixin";
  import {SET_REGION_ERROR} from "@/store/modules/region.module";
  import {SET_LANGUAGE_ERROR} from "@/store/modules/language.module";

  export default {
    name: "index",
    components: { Portlet, pagination, NoResult },
    mixins: [languageMixin, formBusyMixin, commonMethodMixin, msgBoxConfirmMixin],
    data(){
      return {
        languageBusy: false,
        page: 1,
        title: ''
      };
    },
    computed: {},
    created() {
      this.getLanguages();
    },
    mounted() {
      BreadCrumbs.setBreadCrumb([]);
      BreadCrumbs.addBreadCrumb({title: 'تىل باشقۇرۇش', route: {name: 'language.home'}});
      BreadCrumbs.addBreadCrumb({title: 'بارلىق تىللار'});
    },
    methods: {
      onChangePage(e){
        let { title, page } = e;
        this.page = page; this.title = title;
        this.getLanguages(page, title);
      },
      onRefresh(title){
        this.getLanguages(1, title);
      },
      onChangeSwitch(id, column, value){
        this.switchColumn({
          resource: 'films/languages',
          id, column, mutationType: SET_LANGUAGE_ERROR,
          begin: ()=>{ this.showBusy('languageBusy') },
          after: ()=>{ this.hideBusy('languageBusy') },
        });
      },
      onClickDelete(id){
        this.msgBoxConfirm({
          message: 'مەزكۇر تىل ئۇچۇرىنى ئۆچۈرسىڭىز ئەسلىگە قايتۇرالمايسىز، يەنىلا ئۆچۈرۈشنى جەزىملەشتۈرەمسىز ؟',
          confirmCallback: confirm=>{
            if ( confirm ){
              this.deleteModel({
                id, mutationType: SET_REGION_ERROR, resource: 'films/languages',
                begin: ()=>{ this.showBusy('languageBusy')},
                after: ()=>{
                  let { title, page } = this;
                  this.getLanguages(page, title);
                  this.hideBusy('languageBusy');
                },
              })
            }
          }
        });
      }
    }
  }
</script>

<style scoped>

</style>
